var _classCallCheck = require("/home/runner/work/tellow.nl/tellow.nl/apps/leadsite/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/runner/work/tellow.nl/tellow.nl/apps/leadsite/node_modules/@babel/runtime/helpers/createClass.js");
var _require = require("./OptionsBuilder"),
  buildOptions = _require.buildOptions;
var OrderedObjParser = require("./OrderedObjParser");
var _require2 = require("./node2json"),
  prettify = _require2.prettify;
var validator = require('../validator');
var XMLParser = /*#__PURE__*/function () {
  "use strict";

  function XMLParser(options) {
    _classCallCheck(this, XMLParser);
    this.externalEntities = {};
    this.options = buildOptions(options);
  }
  /**
   * Parse XML dats to JS object 
   * @param {string|Buffer} xmlData 
   * @param {boolean|Object} validationOption 
   */
  _createClass(XMLParser, [{
    key: "parse",
    value: function parse(xmlData, validationOption) {
      if (typeof xmlData === "string") {} else if (xmlData.toString) {
        xmlData = xmlData.toString();
      } else {
        throw new Error("XML data is accepted in String or Bytes[] form.");
      }
      if (validationOption) {
        if (validationOption === true) validationOption = {}; //validate with default options

        var result = validator.validate(xmlData, validationOption);
        if (result !== true) {
          throw Error("".concat(result.err.msg, ":").concat(result.err.line, ":").concat(result.err.col));
        }
      }
      var orderedObjParser = new OrderedObjParser(this.options);
      orderedObjParser.addExternalEntities(this.externalEntities);
      var orderedResult = orderedObjParser.parseXml(xmlData);
      if (this.options.preserveOrder || orderedResult === undefined) return orderedResult;else return prettify(orderedResult, this.options);
    }

    /**
     * Add Entity which is not by default supported by this library
     * @param {string} key 
     * @param {string} value 
     */
  }, {
    key: "addEntity",
    value: function addEntity(key, value) {
      if (value.indexOf("&") !== -1) {
        throw new Error("Entity value can't have '&'");
      } else if (key.indexOf("&") !== -1 || key.indexOf(";") !== -1) {
        throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
      } else if (value === "&") {
        throw new Error("An entity with value '&' is not permitted");
      } else {
        this.externalEntities[key] = value;
      }
    }
  }]);
  return XMLParser;
}();
module.exports = XMLParser;